export class SortConfig {
    columns: { [key: string]: SortColumnConfig } = {};
}

export class SortColumnConfig {
    selected: boolean;
    reverse: boolean;
}